/* eslint-disable no-nested-ternary */

import React from 'react';
import PropTypes from 'prop-types';

const ListGroupItemDrugOverdose = ({ data }) => {
  const detailObject = data.attributes.detailObject
    ? JSON.parse(data.attributes.detailObject)
    : data.attributes.detail
      ? data.attributes.detail
      : {};

  return (
    <span className="ml-2">
      {(data.relationships.location || data.attributes.location) && `Overdose occured ${
      data.relationships.location.attributes.isHomeAddress || data.attributes.isHomeAddress
        ? 'at home.'
        : 'away from home.'}`}{' '}
      {detailObject.naloxoneAdministered &&
      detailObject.naloxoneAdministered === 'yes'
        ? 'Naloxone given.'
        : detailObject.naloxoneAdministered === 'no'
          ? 'Naloxone not given.'
          : 'Unknown if naloxone was given.'}
    </span>
  );
};

ListGroupItemDrugOverdose.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default ListGroupItemDrugOverdose;
